import HTForm from '../form/htform';
import { formInvalidMessage } from '../validation/validationhelpers';

export default class EmailLinkForm extends HTForm {
    setup(props) {
        return {
            fields: [
                {
                    name: 'Email',
                    type: 'textfield',
                    value: '',
                    label: 'Email address',
                    rules: 'required|email',
                    extra: {
                        type: 'email',
                        maxLength: 255
                    }
                },
                {
                    name: 'EmailVerify',
                    type: 'textfield',
                    value: '',
                    label: 'Verify email address',
                    rules: 'required|email|same:Email',
                    extra: {
                        type: 'email',
                        maxLength: 255
                    }
                }
            ]
        };
    };

    hooks() {
        return {
            onSuccess(form) {
                const values = form.values();
                this.store.emailLink(values, form);
            },
            onError(form) {
                form.invalidate(formInvalidMessage);
            }
        };
    };
}
